import { render, staticRenderFns } from "./LeaderBoards.vue?vue&type=template&id=8cb0ed56&scoped=true&"
import script from "./LeaderBoards.vue?vue&type=script&lang=js&"
export * from "./LeaderBoards.vue?vue&type=script&lang=js&"
import style0 from "./LeaderBoards.vue?vue&type=style&index=0&id=8cb0ed56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb0ed56",
  null
  
)

export default component.exports